import { getFullVelocityUrl, getUserName } from '@/Helper';
import { UserProfileDropdownAction } from '@/model/CommonModel';
import { UserIcon } from '@/resources/Icons';
import { CaretDownOutlined, InfoCircleOutlined, LogoutOutlined, QuestionCircleOutlined, SettingOutlined } from '@ant-design/icons';
import { MenuProps } from 'antd';
import { MenuClickEventHandler } from 'rc-menu/lib/interface';
import React, { FC, useState } from 'react';
import { AboutModal } from '../AboutModal/AboutModal';
import { DropdownMenu } from '../DropdownMenu/DropdownMenu';
import styles from './operatorMenu.module.scss';

const fullVelocityUrl: string = getFullVelocityUrl();
const helpUrl: string = '/Content/Help/index.htm';
const userName = getUserName();

const createUserMenuItems = (onClick: MenuClickEventHandler): MenuProps['items'] => [
	{
		key: UserProfileDropdownAction.about,
		label: _('About'),
		icon: <InfoCircleOutlined />,
		title: _('About'),
		onClick,
	},
	{
		key: UserProfileDropdownAction.help,
		label: _('Help'),
		icon: <QuestionCircleOutlined />,
		title: _('Help'),
		onClick,
	},
	{
		key: UserProfileDropdownAction.settings,
		label: _('Settings'),
		icon: <SettingOutlined data-leavetab={true} />,
		title: _('Settings'),
		onClick,
	},
	{
		key: UserProfileDropdownAction.logout,
		label: _('Logout'),
		icon: <LogoutOutlined data-leavetab={true} />,
		title: _('Logout'),
		onClick,
	},
];

const OperatorMenu: FC = () => {
	//#region state management variables
	const [displayAboutModal, setDisplayAboutModal] = useState<boolean>(false);
	//#endregion

	const handleActionScope: MenuClickEventHandler = async ({ key }) => {
		const action: UserProfileDropdownAction = UserProfileDropdownAction[key];
		switch (action) {
			case UserProfileDropdownAction.about:
				setDisplayAboutModal(true);
				break;
			case UserProfileDropdownAction.help:
				window.open(`${fullVelocityUrl}${helpUrl}`, '_blank', 'noopener,noreferrer');
				break;
			case UserProfileDropdownAction.settings:
				window.location.href = `${fullVelocityUrl}Configuration/ConfigurationManager`;
				break;
			case UserProfileDropdownAction.logout:
				window.location.href = `${fullVelocityUrl}/Account/LogOff`;
				break;
		}
	};

	return (
		<>
			<DropdownMenu
				className={styles.operatorDropdown}
				label={userName}
				items={createUserMenuItems(handleActionScope)}
				title={userName}
				overlayClassName={styles.overlayCN}
				icon={
					<div className={styles.userIcon}>
						<UserIcon />
					</div>
				}
				labelIcon={<CaretDownOutlined />}
			/>
			{displayAboutModal && <AboutModal hideModal={() => setDisplayAboutModal(false)} />}
		</>
	);
};

export { OperatorMenu };
